import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const PatientDetails = React.lazy(() => import('../../views/PatientDetails'));

const params = [];
const PatientDetailsRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <PatientDetails />
      </Layout>
    </RouteParameter>
  );
};

PatientDetailsRoute.propTypes = {};

PatientDetailsRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PatientDetailsRoute);
